export default {"src":"/_next/static/media/bg-circle.0c0ee79f.svg","height":1330,"width":1213};